import React, { useEffect, createElement } from 'react';
import { TopBanner } from './components/TopBanner';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusSection } from './components/BonusSection';
import { MegapackShowcase } from './components/MegapackShowcase';
import { EbookPreviewSection } from './components/EbookPreviewSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { BuyerPopup } from './components/BuyerPopup';
import { LiveVisitors } from './components/LiveVisitors';
function App() {
  useEffect(() => {
    // META PIXEL INTEGRATION
    const pixelId = 'XXXXXXXXXXXXXXXXX';
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        if (n.callMethod) {
          n.callMethod.apply(n, args);
        } else {
          n.queue.push(args);
        }
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      (window as any).fbq('init', pixelId);
      (window as any).fbq('track', 'PageView');
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }
  }, []);
  return <div className="min-h-screen bg-white relative font-sans" data-id="element-0">
      <TopBanner data-id="element-1" />
      <HeroSection data-id="element-2" />

      {/* Wave Divider */}
      <div className="relative h-12 bg-white -mt-1 z-20" data-id="element-3">
        <svg className="absolute bottom-0 w-full h-full text-white fill-current" viewBox="0 0 1440 320" preserveAspectRatio="none" data-id="element-4">
          <path fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z" data-id="element-5"></path>
        </svg>
      </div>

      <ProblemSection data-id="element-6" />
      <SolutionSection data-id="element-7" />
      <BonusSection data-id="element-8" />
      <MegapackShowcase data-id="element-9" />
      <EbookPreviewSection data-id="element-10" />
      <PricingSection data-id="element-11" />
      <TestimonialsSection data-id="element-12" />
      <FAQSection data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />

      {/* Floating Elements */}
      <BuyerPopup data-id="element-16" />
      <LiveVisitors data-id="element-17" />
    </div>;
}
export { App };